<template>
  <div
    class="fit bg-center-cover-no-repeat animate_scale_in"
    :style="{
      backgroundImage: `url(${require('@/assets/login-bg.jpg')})`,
    }"
  >
    <div class="fit row items-center relative-position" id="_tl_auth_frame">
      <!-- <Login /> -->
      <div
        id="_tlqn_login_frame"
        class="rounded-borders shadow-24 q-pa-md q-px-lg"
      >
        <!-- logo -->
        <section class="full-width row justify-center q-mb-md">
          <img
            :src="require('@/assets/gs-logo.png')"
            draggable="false"
            @contextmenu.prevent
            style="height: 30px"
          />
        </section>

        <!-- title -->
        <div class="login-title section text-center">
          浙江省小微企业调查2021
        </div>

        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Login: () => import("./Login"),
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";
#_tl_auth_frame {
  background-color: rgba(#000, 0.3);
  animation-name: blurIn;
  animation-duration: 1s;
  animation-delay: 0;
  animation-direction: normal;
  /* animation-fill-mode: forwards; */
  animation-iteration-count: 1;
  @keyframes blurIn {
    from {
      backdrop-filter: blur(40px);
    }
    to {
      backdrop-filter: blur(0);
    }
  }
}

/* .animate_scale_in {
  animation: scaleIn 1.2s ease 0s 1 normal;
  @keyframes scaleIn {
    from {
      background-size: 110%;
    }
    to {
      background-size: 100%;
    }
  }
} */

#_tlqn_login_frame {
  width: 400px;
  height: 600px;
  border: 2px solid $tailong-dark-blue;
  background-color: #f6f6f6;

  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  @media screen and(min-width: 800px) {
    right: 15%;
    left: unset;
    transform: translateX(0%);
  }
}

.login-title {
  font-size: 2rem;
  font-weight: bold;
  color: $tailong-dark-blue;
}
</style>
